import React from 'react';

import * as ViewHooks from '../../../../state/views/hooks';
import {panelViews} from '../../../PanelBank/types';
import {MediaSettingsDrawerContent} from './MediaSettingsDrawerContent';
import {
  MediaSettingsDrawerContextProvider,
  useMediaSettingsDrawer,
} from './MediaSettingsDrawerContextProvider';
import {MediaSettingsDrawerPanelProps} from './types';

const MediaSettingsDrawerDataLoader = (
  props: MediaSettingsDrawerPanelProps
) => {
  const contextValue = useMediaSettingsDrawer(props);
  return (
    <MediaSettingsDrawerContextProvider contextValue={contextValue}>
      <MediaSettingsDrawerContent />
    </MediaSettingsDrawerContextProvider>
  );
};

export const MediaSettingsDrawer = ({
  panelRef,
  panelBankSectionConfigRef,
}: MediaSettingsDrawerPanelProps) => {
  const panel = ViewHooks.usePart(panelRef);
  if (panel.viewType !== panelViews.mediaBrowser) {
    return null;
  }
  return (
    <MediaSettingsDrawerDataLoader
      panelRef={panelRef}
      panelBankSectionConfigRef={panelBankSectionConfigRef}
    />
  );
};
